export default __webpack_public_path__ + "static/media/schoolsIcon.14df25d8.svg";